//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/smsSystems/views/main/lan/es';
import createEditSmsSystem from 'Modules/smsSystems/views/.components/createEditSmsSystem/lan/es';
import deleteSmsSystem from 'Modules/smsSystems/views/.components/deleteSmsSystem/lan/es';

locales = { ...locales, ...main, ...createEditSmsSystem, ...deleteSmsSystem };

export default locales;